import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../images/logoNew.png";

import axios from "axios";
import CryptoJS from "crypto-js";
import Container from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import LoginImg from "../images/loginDoctorImage.webp";
import { encryptData } from "../Services/TabServices";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export default function DoctorLogin() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [activeTab, setActiveTab] = useState<"Mobile" | "Password">("Mobile");
  const [formData, setFormData] = useState<any>({ PhoneNo: "", Password: "" });
  const [formDataOtp, setFormDataOtp] = useState<any>({ otp: "" });
  const [verifyOtpPage, setVerifyOtpPage] = useState<boolean>(false);
  const [encryptedOTP, setEncryptedOtp] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [userType, setUserType] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const [isOtpLoading, setOtpLoading] = useState<boolean>(false);
  const [isPasswordLoading, setPasswordLoading] = useState<boolean>(false);
  const [isVerifyOtpLoading, setVerifyOtpLoading] = useState<boolean>(false);

  const [timer, setTimer] = useState<number>(0);

  // ✅ FIXED: handleChange — only digits, first digit must be 6-9, max 10 digits
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "PhoneNo") {
      // Allow only digits
      if (!/^\d*$/.test(value)) return;
      // First digit must be 6, 7, 8, or 9
      if (value.length >= 1 && !/^[6-9]/.test(value)) return;
      // Max 10 digits
      if (value.length > 10) return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleChangeOtp = (e: any) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    if (value.length > 6) return;
    setFormDataOtp({ ...formDataOtp, [name]: value });
  };

  // ✅ Shared PhoneNo validation before API calls
  const isValidPhone = (phone: string) =>
    /^[6-9]\d{9}$/.test(phone);

  // send OTP (Phone only)
  const handleSendOtp = async (event?: React.FormEvent) => {
    if (event) event.preventDefault();
    setError("");

    if (!isValidPhone(formData.PhoneNo)) {
      setError("Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
      return;
    }

    setOtpLoading(true);
    setTimer(20);

    if (!executeRecaptcha) {
      setError("reCAPTCHA not ready. Please try again.");
      setOtpLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("callback_request");

    if (!recaptchaToken) {
      setError("Captcha verification failed. Please try again.");
      setOtpLoading(false);
      return;
    }

    try {
      const payload = {
        phoneNo: formData.PhoneNo,
        Passwrd: "",
        loginType: "otp"
      };

      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/DoctorLogin`,
        {recaptchaToken},
        { params: payload }
      );

      setEncryptedOtp(response.data[0].encryptedOtp);
      setToken(response.data[0].token);
      setUserId(response.data[0].userId);
      setUserType(response.data[0].userType);
      setVerifyOtpPage(true);
      setFormData({ PhoneNo: "", Password: "" });
    } catch (error: any) {
      console.error("Error in sending OTP", error);
      setError(error?.response?.data || "Failed to send OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  // Password login
  const handlePasswordLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);

    if (!isValidPhone(formData.PhoneNo)) {
      setError("Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
      return;
    }

    setPasswordLoading(true);

    if (!executeRecaptcha) {
      setError("reCAPTCHA not ready. Please try again.");
      setPasswordLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("callback_request");

    if (!recaptchaToken) {
      setError("Captcha verification failed. Please try again.");
      setPasswordLoading(false);
      return;
    }

    try {
      const payload = {
        PhoneNo: formData.PhoneNo,
        Passwrd: formData.Password,
        loginType: "",
           };

      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/DoctorLogin`,{recaptchaToken},
        { params: payload }
      );

      handleLoginSuccess(
        response.data[0].userType,
        response.data[0].token,
        response.data[0].userId
      );
      setFormData({ PhoneNo: "", Password: "" });
    } catch (error: any) {
      setError("Invalid Password or Mobile number.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleLoginSuccess = (
    userTypeVal: string,
    tokenVal: string,
    userIdVal: string
  ) => {
    if (userTypeVal === "D") {
      sessionStorage.setItem("userType", userTypeVal);
      sessionStorage.setItem("token", tokenVal);
      const encryptedId = encryptData(userIdVal);
      sessionStorage.setItem("userId", encryptedId);
      sessionStorage.setItem("activepage", "Home");
      navigate("/doctorDashboard");
    } else {
      setError("This login is only for Doctors");
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setVerifyOtpLoading(true);
    const secretKey = "12345678912345698745632165498712";
    const EncryptionIV = "1234569874123659";

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedOTP,
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: CryptoJS.enc.Utf8.parse(EncryptionIV) }
      );
      const otp = bytes.toString(CryptoJS.enc.Utf8);
      if (!otp) return setError("OTP expired. Please request a new one.");
      if (otp === formDataOtp.otp) {
        handleLoginSuccess(userType, token, userId);
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error("Decryption failed", err);
    } finally {
      setVerifyOtpLoading(false);
    }
  };

  useEffect(() => {
    let interval: any;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // ✅ Reusable PhoneNo TextField props (used in all 3 breakpoints × 2 tabs)
  const phoneFieldProps = (height: string, borderRadius: string, fontSize: string) => ({
    required: true,
    label: "Mobile Number",
    name: "PhoneNo",
    value: formData.PhoneNo,
    fullWidth: true,
    size: "small" as const,
    onChange: handleChange,
    inputProps: {
      maxLength: 10,
      inputMode: "numeric" as const,
      pattern: "[6-9][0-9]{9}",
    },
    InputProps: {
      startAdornment: <span className="mr-2 text-gray-600 font-medium">+91</span>,
    },
    sx: {
      "& .MuiInputBase-root": {
        height,
        borderRadius,
        fontSize,
      },
    },
  });

  return (
    <Container
      open={true}
      aria-labelledby="modal-modal-title"
      onClose={() => navigate("/doctorLogin")}
    >
      <div>
        {/* ===================== MOBILE VIEW ===================== */}
        <div className="block md:hidden absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl w-[92%] max-h-[85vh] overflow-y-auto">
          <div className="px-6 py-8 pt-8">
            {verifyOtpPage ? (
              /* Mobile OTP Verification */
              <div className="text-center space-y-6">
                <div className="space-y-3">
                  <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                    <img src={logo} alt="" />
                  </div>
                  <h1 className="text-2xl font-bold text-gray-900">Verify Now</h1>
                  <p className="text-gray-600 text-sm leading-relaxed px-2">
                    A verification code has been sent to your mobile number.
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-5">
                  <TextField
                    required
                    label="Enter OTP"
                    name="otp"
                    value={formDataOtp.otp}
                    fullWidth
                    size="small"
                    onChange={handleChangeOtp}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "52px",
                        borderRadius: "16px",
                        fontSize: "16px",
                      },
                    }}
                  />
                  <div className="text-center py-2">
                    {timer > 0 ? (
                      <p className="text-gray-600 text-sm">
                        Resend code in{" "}
                        <span className="font-semibold text-teal-600">{timer}s</span>
                      </p>
                    ) : (
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        className="text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                  {error && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                      <p className="text-red-700 text-sm font-medium">{error}</p>
                    </div>
                  )}
                  <button
                    type="submit"
                    disabled={isVerifyOtpLoading}
                    className={`w-full py-4 rounded-2xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                      isVerifyOtpLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                    }`}
                  >
                    {isVerifyOtpLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                        </svg>
                        <span>Verifying...</span>
                      </div>
                    ) : (
                      "Verify OTP"
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => { setVerifyOtpPage(false); setError(""); }}
                    className="w-full py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-200"
                  >
                    ← Go Back
                  </button>
                </form>
              </div>
            ) : (
              /* Mobile Login Form */
              <div className="text-center space-y-6">
                <div className="space-y-3">
                  <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                    <img src={logo} alt="" />
                  </div>
                  <h1 className="text-2xl font-bold text-gray-900">Doctor Login</h1>
                  <p className="text-gray-600 text-sm leading-relaxed px-2">
                    Secure access to your medical dashboard
                  </p>
                </div>
                <div className="flex bg-gray-100 rounded-xl p-1 w-full">
                  <button
                    onClick={() => setActiveTab("Mobile")}
                    className={`flex-1 py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ${
                      activeTab === "Mobile" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                    }`}
                  >
                    OTP Login
                  </button>
                  <button
                    onClick={() => setActiveTab("Password")}
                    className={`flex-1 py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ${
                      activeTab === "Password" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                    }`}
                  >
                    Password
                  </button>
                </div>
                <div className="space-y-5">
                  {activeTab === "Mobile" && (
                    <form onSubmit={handleSendOtp} className="space-y-4">
                      {/* ✅ FIXED PhoneNo field */}
                      <TextField {...phoneFieldProps("52px", "16px", "16px")} />
                      <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-left">
                        <div className="flex items-start space-x-2">
                          <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <p className="text-blue-700 text-xs leading-relaxed">
                            We'll send you a secure verification code to complete your login.
                          </p>
                        </div>
                      </div>
                      {error && (
                        <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg text-left">
                          <p className="text-red-700 text-sm font-medium">{error}</p>
                        </div>
                      )}
                      <button
                        type="submit"
                        disabled={isOtpLoading}
                        className={`w-full py-4 rounded-2xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                          isOtpLoading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                        }`}
                      >
                        {isOtpLoading ? (
                          <div className="flex items-center justify-center space-x-2">
                            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                            </svg>
                            <span>Sending OTP...</span>
                          </div>
                        ) : (
                          "Send OTP"
                        )}
                      </button>
                    </form>
                  )}
                  {activeTab === "Password" && (
                    <form onSubmit={handlePasswordLogin} className="space-y-4 text-left">
                      {/* ✅ FIXED PhoneNo field */}
                      <TextField {...phoneFieldProps("52px", "16px", "16px")} />
                      <TextField
                        required
                        label="Password"
                        name="Password"
                        type={showPassword ? "text" : "password"}
                        value={formData.Password}
                        fullWidth
                        size="small"
                        onChange={handleChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "52px",
                            borderRadius: "16px",
                            fontSize: "16px",
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword((prev) => !prev)}
                                edge="end"
                                size="small"
                                sx={{ p: 0.5 }}
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {error && (
                        <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                          <p className="text-red-700 text-sm font-medium">{error}</p>
                        </div>
                      )}
                      <button
                        type="submit"
                        disabled={isPasswordLoading}
                        className={`w-full py-4 rounded-2xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                          isPasswordLoading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                        }`}
                      >
                        {isPasswordLoading ? (
                          <div className="flex items-center justify-center space-x-2">
                            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                            </svg>
                            <span>Logging in...</span>
                          </div>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ===================== TABLET VIEW ===================== */}
        <div className="hidden md:block lg:hidden absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl w-[70%] max-h-[85vh] overflow-y-auto">
          <div className="flex flex-row justify-between items-center gap-8">
            <div className="flex items-center justify-center w-1/2">
              <div className="w-full max-w-sm">
                <img src={LoginImg} alt="Login" className="w-full h-auto object-contain rounded-lg shadow-md" />
              </div>
            </div>
            <div className="w-3/5 pr-4">
              {verifyOtpPage ? (
                <div className="text-center space-y-5">
                  <div className="space-y-2">
                    <h1 className="text-xl font-bold text-gray-900">Verify Now</h1>
                    <p className="text-gray-600 text-sm leading-relaxed px-2">
                      A verification code has been sent to your mobile number.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <TextField
                      required
                      label="Enter OTP"
                      name="otp"
                      value={formDataOtp.otp}
                      fullWidth
                      size="small"
                      onChange={handleChangeOtp}
                      sx={{
                        "& .MuiInputBase-root": { height: "48px", borderRadius: "14px", fontSize: "15px" },
                      }}
                    />
                    <div className="text-center py-1">
                      {timer > 0 ? (
                        <p className="text-gray-600 text-sm">
                          Resend code in <span className="font-semibold text-teal-600">{timer}s</span>
                        </p>
                      ) : (
                        <button
                          type="button"
                          onClick={handleSendOtp}
                          className="text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                        >
                          Resend OTP
                        </button>
                      )}
                    </div>
                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-3 rounded-lg">
                        <p className="text-red-700 text-sm font-medium">{error}</p>
                      </div>
                    )}
                    <button
                      type="submit"
                      disabled={isVerifyOtpLoading}
                      className={`w-full py-3 rounded-xl text-white font-semibold text-sm transition-all duration-200 shadow-lg ${
                        isVerifyOtpLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isVerifyOtpLoading ? (
                        <div className="flex items-center justify-center space-x-2">
                          <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                          </svg>
                          <span>Verifying...</span>
                        </div>
                      ) : (
                        "Verify OTP"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => { setVerifyOtpPage(false); setError(""); }}
                      className="w-full py-2.5 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-200"
                    >
                      ← Go Back
                    </button>
                  </form>
                </div>
              ) : (
                <div className="text-center space-y-5">
                  <div className="space-y-2">
                    <h1 className="text-xl font-bold text-gray-900">Doctor Login</h1>
                    <p className="text-gray-600 text-sm leading-relaxed px-2">
                      Secure access to your medical dashboard
                    </p>
                  </div>
                  <div className="flex bg-gray-100 rounded-xl p-1 w-full">
                    <button
                      onClick={() => setActiveTab("Mobile")}
                      className={`flex-1 py-2 px-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
                        activeTab === "Mobile" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                      }`}
                    >
                      OTP Login
                    </button>
                    <button
                      onClick={() => setActiveTab("Password")}
                      className={`flex-1 py-2 px-3 rounded-lg text-sm font-semibold transition-all duration-200 ${
                        activeTab === "Password" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                      }`}
                    >
                      Password
                    </button>
                  </div>
                  <div className="space-y-4">
                    {activeTab === "Mobile" && (
                      <form onSubmit={handleSendOtp} className="space-y-3 text-left">
                        {/* ✅ FIXED PhoneNo field */}
                        <TextField {...phoneFieldProps("48px", "14px", "15px")} />
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                          <div className="flex items-start space-x-2">
                            <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-blue-700 text-xs leading-relaxed">
                              We'll send you a secure verification code to complete your login.
                            </p>
                          </div>
                        </div>
                        {error && (
                          <div className="bg-red-50 border-l-4 border-red-400 p-3 rounded-lg">
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                          </div>
                        )}
                        <button
                          type="submit"
                          disabled={isOtpLoading}
                          className={`w-full py-3 rounded-xl text-white font-semibold text-sm transition-all duration-200 shadow-lg ${
                            isOtpLoading
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                          }`}
                        >
                          {isOtpLoading ? (
                            <div className="flex items-center justify-center space-x-2">
                              <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                              </svg>
                              <span>Sending OTP...</span>
                            </div>
                          ) : (
                            "Send OTP"
                          )}
                        </button>
                      </form>
                    )}
                    {activeTab === "Password" && (
                      <form onSubmit={handlePasswordLogin} className="space-y-3 text-left">
                        {/* ✅ FIXED PhoneNo field */}
                        <TextField {...phoneFieldProps("48px", "14px", "15px")} />
                        <TextField
                          required
                          label="Password"
                          name="Password"
                          type={showPassword ? "text" : "password"}
                          value={formData.Password}
                          fullWidth
                          size="small"
                          onChange={handleChange}
                          sx={{
                            "& .MuiInputBase-root": { height: "48px", borderRadius: "14px", fontSize: "15px" },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" size="small" sx={{ p: 0.5 }}>
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {error && (
                          <div className="bg-red-50 border-l-4 border-red-400 p-3 rounded-lg">
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                          </div>
                        )}
                        <button
                          type="submit"
                          disabled={isPasswordLoading}
                          className={`w-full py-3 rounded-xl text-white font-semibold text-sm transition-all duration-200 shadow-lg ${
                            isPasswordLoading
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                          }`}
                        >
                          {isPasswordLoading ? (
                            <div className="flex items-center justify-center space-x-2">
                              <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                              </svg>
                              <span>Logging in...</span>
                            </div>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </form>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ===================== DESKTOP VIEW ===================== */}
        <div className="hidden lg:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl w-[90%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-[900px] max-h-[80vh] overflow-y-auto">
          <CloseIcon className="float-right p-1 rounded-full text-white" />
          <div className="flex flex-row justify-between items-center gap-8">
            <div className="flex items-center justify-center w-1/2 px-4">
              <div className="w-full max-w-sm">
                <img src={LoginImg} alt="Login" className="w-full h-auto object-contain rounded-lg shadow-md" />
              </div>
            </div>
            <div className="w-1/2">
              {verifyOtpPage ? (
                <div className="text-center space-y-6">
                  <div className="space-y-3">
                    <h1 className="text-2xl font-bold text-gray-900">Verify Now</h1>
                    <p className="text-gray-600 text-sm leading-relaxed px-2">
                      A verification code has been sent to your mobile number.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit} className="space-y-5">
                    <TextField
                      required
                      label="Enter OTP"
                      name="otp"
                      value={formDataOtp.otp}
                      fullWidth
                      size="small"
                      onChange={handleChangeOtp}
                      sx={{
                        "& .MuiInputBase-root": { height: "48px", borderRadius: "12px", fontSize: "16px" },
                      }}
                    />
                    <div className="text-center py-2">
                      {timer > 0 ? (
                        <p className="text-gray-600 text-sm">
                          Resend code in <span className="font-semibold text-teal-600">{timer}s</span>
                        </p>
                      ) : (
                        <button
                          type="button"
                          onClick={handleSendOtp}
                          className="text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                        >
                          Resend OTP
                        </button>
                      )}
                    </div>
                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                        <p className="text-red-700 text-sm font-medium">{error}</p>
                      </div>
                    )}
                    <button
                      type="submit"
                      disabled={isVerifyOtpLoading}
                      className={`w-full py-3 rounded-xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                        isVerifyOtpLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isVerifyOtpLoading ? (
                        <div className="flex items-center justify-center space-x-2">
                          <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                          </svg>
                          <span>Verifying...</span>
                        </div>
                      ) : (
                        "Verify OTP"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => { setVerifyOtpPage(false); setError(""); }}
                      className="w-full py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-200"
                    >
                      ← Go Back
                    </button>
                  </form>
                </div>
              ) : (
                <div className="text-center space-y-6">
                  <div className="space-y-3">
                    <h1 className="text-2xl font-bold text-gray-900">Doctor Login</h1>
                    <p className="text-gray-600 text-sm leading-relaxed px-2">
                      Secure access to your medical dashboard
                    </p>
                  </div>
                  <div className="flex bg-gray-100 rounded-xl p-1 w-full">
                    <button
                      onClick={() => setActiveTab("Mobile")}
                      className={`flex-1 py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ${
                        activeTab === "Mobile" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                      }`}
                    >
                      OTP Login
                    </button>
                    <button
                      onClick={() => setActiveTab("Password")}
                      className={`flex-1 py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ${
                        activeTab === "Password" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-800"
                      }`}
                    >
                      Password
                    </button>
                  </div>
                  <div className="space-y-5">
                    {activeTab === "Mobile" && (
                      <form onSubmit={handleSendOtp} className="space-y-4 text-left">
                        {/* ✅ FIXED PhoneNo field */}
                        <TextField {...phoneFieldProps("52px", "16px", "16px")} />
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-1">
                          <div className="flex items-start space-x-2">
                            <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-blue-700 text-xs leading-relaxed">
                              We'll send you a secure verification code to complete your login.
                            </p>
                          </div>
                        </div>
                        {error && (
                          <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                          </div>
                        )}
                        <button
                          type="submit"
                          disabled={isOtpLoading}
                          className={`w-full py-3 rounded-xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                            isOtpLoading
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                          }`}
                        >
                          {isOtpLoading ? (
                            <div className="flex items-center justify-center space-x-2">
                              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                              </svg>
                              <span>Sending OTP...</span>
                            </div>
                          ) : (
                            "Send OTP"
                          )}
                        </button>
                      </form>
                    )}
                    {activeTab === "Password" && (
                      <form onSubmit={handlePasswordLogin} className="space-y-4 text-left">
                        {/* ✅ FIXED PhoneNo field */}
                        <TextField {...phoneFieldProps("52px", "16px", "16px")} />
                        <TextField
                          required
                          label="Password"
                          name="Password"
                          type={showPassword ? "text" : "password"}
                          value={formData.Password}
                          fullWidth
                          size="small"
                          onChange={handleChange}
                          sx={{
                            "& .MuiInputBase-root": { height: "48px", borderRadius: "12px", fontSize: "16px" },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" size="small" sx={{ p: 0.5 }}>
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {error && (
                          <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                          </div>
                        )}
                        <button
                          type="submit"
                          disabled={isPasswordLoading}
                          className={`w-full py-3 rounded-xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                            isPasswordLoading
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                          }`}
                        >
                          {isPasswordLoading ? (
                            <div className="flex items-center justify-center space-x-2">
                              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                              </svg>
                              <span>Logging in...</span>
                            </div>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </form>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
